// Long tasks (>50ms) block the main thread and delay when microfrontend
// content can start loading, so we accumulate them from the earliest possible
// point in the bootstrap.
const LONG_TASK_THRESHOLD_MS = 50;

let blockingMs = 0;
let longTaskCount = 0;
let longestTaskMs = 0;
let tracking = false;
let observer: PerformanceObserver | undefined;

function recordLongTasks(entries: PerformanceEntry[]) {
  entries.forEach((entry) => {
    longTaskCount += 1;
    blockingMs += Math.max(0, entry.duration - LONG_TASK_THRESHOLD_MS);
    longestTaskMs = Math.max(longestTaskMs, entry.duration);
  });
}

export function startMainThreadBlockingTracking() {
  if (tracking || typeof PerformanceObserver === 'undefined') return;

  try {
    observer = new PerformanceObserver((list) => {
      recordLongTasks(list.getEntries());
    });
    observer.observe({ buffered: true, type: 'longtask' });
    tracking = true;
  } catch {
    observer?.disconnect();
    observer = undefined;
    tracking = false;
  }
}

export function getMainThreadBlocking() {
  if (observer) {
    recordLongTasks(Array.from(observer.takeRecords()));
  }

  const metrics = {
    long_task_count: longTaskCount,
    longest_task_ms: Math.round(longestTaskMs),
    main_thread_blocking_ms: Math.round(blockingMs),
    tracking_supported: tracking,
  };

  observer?.disconnect();
  observer = undefined;
  tracking = false;

  return metrics;
}
